import React, { useEffect, useState } from "react";
import "./upgradeNow.scss";
import Image from "next/image";
import Link from "next/link";
import template01 from "@/../public/modals/upgrade-now/cards-02.png";
import template02 from "@/../public/modals/upgrade-now/cards-03.png";
import template03 from "@/../public/modals/upgrade-now/cards-04.png";
import template04 from "@/../public/modals/upgrade-now/cards-05.png";

import bg from "@/../public/modals/upgrade-now/bg.png";
import closeBtn from "@/../public/modals/upgrade-now/close-btn.png";
import { allRoutes } from "@/data/allRoutes";
const templates = [template01, template02, template03, template04];

export default function UpgradeNowModal({
  setOpenUpgradeNowModal,
  userDataSelector,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % templates.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex-col-center UpgradeNowModal">
      <div className="flex-row-center overlayContainer">
        <Link
          href={
            userDataSelector ? allRoutes.pricing : "/signin?path=%2Fpricing"
          }
        >
          <div className="bgImg">
            <Image src={bg} alt="background" />
          </div>
          <div className="flex-row-center mainContainer">
            <Image
              src={templates[currentIndex]}
              alt={`template-${currentIndex + 1}`}
            />
          </div>
        </Link>
        <div
          onClick={() => setOpenUpgradeNowModal(false)}
          className="flex-row-center closeBtn"
        >
          <Image src={closeBtn} alt="close" />
        </div>
      </div>
    </div>
  );
}
